import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_DigitalIDActivations } from "../shared/data.service";

@Component({
	selector: "app-digital-id-modify-activation",
	templateUrl: "./digital-id-modify-activation.component.html",
	styleUrls: ["./digital-id-modify-activation.component.css"],
})
export class DigitalIdModifyActivationComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private DigitalIDActivationService: DataService_DigitalIDActivations
	) {}

	ngOnInit(): void {
		var SchoolData = this.dialogConfig.data.School;

		this.SchoolID = SchoolData.SchoolID;
		this.SchoolFullName = SchoolData.SchoolFullName;
		this.AvailableCount = SchoolData.AvailableCount;
		this.OriginalAvailableCount = SchoolData.AvailableCount;
		this.TotalCount = SchoolData.TotalCount;
		this.OriginalTotalCount = SchoolData.TotalCount;
	}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////

	SchoolID: number = 0;
	SchoolFullName: string = "";
	AvailableCount: number = 0;
	OriginalAvailableCount: number = 0;
	TotalCount: number = 0;
	OriginalTotalCount: number = 0;

	Processing: boolean = false;

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////
	onUpdate() {
		this.Processing = true;

		var result = this.DigitalIDActivationService.ActivationModify(this.SchoolID, this.AvailableCount, this.TotalCount);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the school",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////
	onAvailableCountChange(val) {
		if (val < 0) {
			this.AvailableCount = 0;
			this.TotalCount = this.OriginalTotalCount - this.OriginalAvailableCount;
		} else {
			var change = val - this.OriginalAvailableCount;
			var newTotal = this.OriginalTotalCount + change;

			this.AvailableCount = val;
			this.TotalCount = newTotal;
		}
	}

	///////////////////////////////////////////////////////////////////////
}
